import axios from 'axios';

const URL = "https://api.openweathermap.org/data/2.5/weather"
const API_KEY = "e3552cbfa6944e7cefde3705403f420a"
export const fetchWeather = async(query) => {
    const {data} = await axios.get(URL,{
        params:{
            q:query,
            units:'metric',
            APPID:API_KEY,

        }
    });
 return data;
}